'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _semanticUiReact = require('semantic-ui-react');

var _reactRedux = require('react-redux');

var _saveUserData = require('redux/modules/saveUserData');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

require('./SaveButton.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./SaveButton.scss');
var SaveButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    content_template_data: state.templateData.content_template_data,
    personal_info: state.templateData.personal_info,
    info_block: state.templateData.info_block,
    design_order: state.templateData.design_order,
    template_data: state.templateData,
    inter_section_margin: state.templateData.inter_section_margin,
    primary_color: state.templateData.primary_color,
    secondary_color: state.templateData.secondary_color,
    header_font: state.templateData.header_font,
    body_font: state.templateData.body_font,
    design_template_name: state.templateData.design_template_name,
    content_template_name: state.templateData.content_template_name,
    resume_review_id: state.templateData.resume_review_id,
    ReactGA: state.company.ReactGA
  };
}, {
  saveUserData: _saveUserData.save
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SaveButton, _Component);

  function SaveButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SaveButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SaveButton.__proto__ || (0, _getPrototypeOf2.default)(SaveButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SaveButton, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {}
  }, {
    key: 'saveState',
    value: function saveState() {
      var object = {};
      object['personal'] = this.props.personal_info;
      object['info'] = this.props.info_block;
      object['design_template_id'] = this.props.template_data.design_template_id;
      object['content_template_id'] = this.props.template_data.content_template_id;
      object['design_order'] = this.props.design_order.toString();
      object['inter_section_margin'] = this.props.template_data.inter_section_margin;
      object['primary_color'] = this.props.template_data.primary_color;
      object['secondary_color'] = this.props.template_data.secondary_color;
      object['header_font'] = this.props.header_font;
      object['body_font'] = this.props.body_font;
      object['resume_name'] = this.props.template_data.resume_name;
      object['resume_review_id'] = this.props.resume_review_id;

      // Converting back to string so that consistency is maintained on data coming from server
      this.props.saveUserData(object);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'saveResumeButtonWrapper' },
        _react2.default.createElement(
          _semanticUiReact.Button,
          { className: 'saveResumeButton', icon: true, labelPosition: 'left', onClick: function onClick(e) {
              return _this2.saveState();
            } },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' }),
          'Save'
        )
      );
    }
  }]);
  return SaveButton;
}(_react.Component)) || _class);
exports.default = SaveButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SaveButton/SaveButton.js
// module id = 1742
// module chunks = 0